/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

/**
 * - BOOK_CONNECTION_STATE_INACTIVE: Scaled to zero due to inactivity; kept for on-demand reactivation.
 */
export type V2BookConnectionState =
  (typeof V2BookConnectionState)[keyof typeof V2BookConnectionState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V2BookConnectionState = {
  BOOK_CONNECTION_STATE_PENDING: 'BOOK_CONNECTION_STATE_PENDING',
  BOOK_CONNECTION_STATE_READY: 'BOOK_CONNECTION_STATE_READY',
  BOOK_CONNECTION_STATE_FAILED: 'BOOK_CONNECTION_STATE_FAILED',
  BOOK_CONNECTION_STATE_CONDITIONS_NOT_MET:
    'BOOK_CONNECTION_STATE_CONDITIONS_NOT_MET',
  BOOK_CONNECTION_STATE_UNKNOWN: 'BOOK_CONNECTION_STATE_UNKNOWN',
  BOOK_CONNECTION_STATE_INACTIVE: 'BOOK_CONNECTION_STATE_INACTIVE',
} as const;
